const footerEn = {
  'footer': {
    'aboutMobile': 'To install mobile application scan the QR-code by your phone camera',
    'aboutPhone': 'Toll-free in Russia',
    'aboutUniCredit': '',
    'aboutLicense': 'AO UniCredit Bank, General license №1 of Bank of Russia',
  },
};

export default footerEn;
